<template>
    <v-app>
        <v-app-bar app dense color="white" elevation="1">
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>Fleet and Operations</v-toolbar-title>
            <v-spacer></v-spacer>
            <ToolbarMenuRight/>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            expand-on-hover
            mini-variant 
            :right="$vuetify.rtl"
            >
            <NavDrawerList :groups="navigations"/>
        </v-navigation-drawer>
        <v-main>
            <router-view></router-view>
        </v-main>
        <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>
    </v-app>
</template>

<script>
import ToolbarMenuRight from './../components/common/ToolbarMenuRight.vue';
import NavDrawerList from './../components/common/NavDrawerList.vue';
import { mapGetters, mapActions } from 'vuex';
import permissions from '../data/permissions';
export default {
    components: {
        ToolbarMenuRight,
        NavDrawerList
    }, 
    data() {
        return {
            drawer: null,
            permissions,
        }
    },
    computed: {
        ...mapGetters({
            snackbar: "ui/snackbar/snackbar"
        }),
        navigations() {
            return [
                // {
                //     text: this.$t("reports"),
                //     icon: "mdi-folder",
                //     items: [
                //         {
                //             text: this.$t("dashboard"),
                //             icon: "mdi-google-analytics",
                //             to: "/fleet/dashboard",
                //             authorization: permissions.vehicle.index
                //         }
                //     ]
                // },
                {
                    text: this.$t("settings"),
                    icon: "mdi-folder",
                    items: [
                        {
                            text: this.$t("vehicles"),
                            icon: "mdi-truck-check",
                            to: "/fleet/vehicles",
                            authorization: permissions.vehicle.index
                        },
                        {
                            text: this.$t("drivers"),
                            icon: "mdi-card-account-details",
                            to: "/fleet/drivers",
                            authorization: permissions.driver.index
                        },
                        {
                            text: this.$t("brands"),
                            icon: "mdi-briefcase-download",
                            to: "/fleet/brands",
                            authorization: permissions.brand.index
                        },
                        {
                            text: this.$t("types"),
                            icon: "mdi-truck",
                            to: "/fleet/vehicle-usages",
                            authorization: permissions.vehicle_usage.index
                        },
                        {
                            text: this.$t("insurance_company"),
                            icon: "mdi-domain",
                            to: "/fleet/insurance-companies",
                            authorization: permissions.insurance_company.index
                        }
                    ]
                },
            ]
        }
    },
    methods: {
        ...mapActions({
            hideSnackbar: "ui/snackbar/hide"
        }),
    }
}
</script>

<style>

</style>